import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  templateUrl: './work-shift-dialog.component.html',
})
export class WorkShiftDialogComponent implements OnInit {
  employeeSession: any;
  loading = false;
  confirmClose = false;
  closeSessionAction: () => Promise<void>;
  getSessionAction: () => Promise<any>;
  getSessionReportAction: () => Promise<any>;

  constructor(private _modalCtrl: ModalController) {}

  ngOnInit() {
    this._getEmployeeSession();
  }

  closeSession = () => {
    this.confirmClose = true;
  };

  confirmCloseSession() {
    this.loading = true;
    this.closeSessionAction().then(() => this._modalCtrl.dismiss());
  }

  cancelCloseSession() {
    this.confirmClose = false;
  }

  async _getEmployeeSession() {
    this.loading = true;
    this.employeeSession = await this.getSessionAction();
    this.loading = false;
  }

  close() {
    this._modalCtrl.dismiss();
  }

  async sessionReport() {
    await this.getSessionReportAction();
  }
}
